"use strict";
/**
 * Validator functions
 *
 * All functions in this file take an input and return a boolean. The `required` option specifies
 * whether it will allow a null value, or empty string for string values.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDate = exports.isEmailAddress = exports.isCreditCardNumber = exports.isBSB = exports.maxValue = exports.minValue = exports.isNumber = exports.maxLength = exports.minLength = exports.isString = exports.isBoolean = void 0;
var Parsers = __importStar(require("../parsers/index"));
/**
 * Validate a boolean value
 */
exports.isBoolean = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && input === null) {
        // Null is allowable when the field is not required
        return true;
    }
    if (typeof input === 'boolean') {
        return true;
    }
    return false;
};
/**
 * Validate a string value
 */
exports.isString = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && input === null) {
        // Null is allowable when the field is not required
        return true;
    }
    if (typeof input === 'string') {
        return true;
    }
    return false;
};
/**
 * Validate min length of string
 */
exports.minLength = function (input, min) {
    if (typeof input !== 'string') {
        return false;
    }
    if (input.length >= min) {
        return true;
    }
    return false;
};
/**
 * Validate max length of string
 */
exports.maxLength = function (input, max) {
    if (typeof input !== 'string') {
        return false;
    }
    if (input.length <= max) {
        return true;
    }
    return false;
};
/**
 * Validate a number value
 */
exports.isNumber = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && input === null) {
        // Null is allowable when the field is not required
        return true;
    }
    if (typeof input === 'number' && !isNaN(input)) {
        // Note: !isNaN() is required when the value could be "Number.NaN" which is typeof number.
        // NaN can occur when:
        // - zero is divided by zero,
        // - infinity is divided by infinity,
        // - infinity and zero are multiplied,
        // - when a non-numeric string or undefined are parsed to a number
        return true;
    }
    return false;
};
/**
 * Validate min value of number
 */
exports.minValue = function (input, min) {
    if (typeof input !== 'number') {
        input = Parsers.parseNumber(input);
        input = parseFloat(input);
    }
    if (isNaN(input)) {
        return false;
    }
    if (input >= min) {
        return true;
    }
    return false;
};
/**
 * Validate max value of number
 */
exports.maxValue = function (input, max) {
    if (typeof input !== 'number') {
        input = Parsers.parseNumber(input);
        input = parseFloat(input);
    }
    if (isNaN(input)) {
        return false;
    }
    if (input <= max) {
        return true;
    }
    return false;
};
/**
 * Validate a BSB number
 */
exports.isBSB = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && (input === null || input === '')) {
        // Null and empty string is allowable when the field is not required
        return true;
    }
    // If the string is the right length, perform a regex
    if (typeof input === 'string' && (input.length === 6 || input.length === 7)) {
        // Regex: 3 digits, optional hypen, 3 digits.
        var matched = input.match(/^\d{3,3}-?\d{3,3}$/);
        if (matched !== null) {
            return true;
        }
    }
    return false;
};
/**
 * Validate a credit card
 */
exports.isCreditCardNumber = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && (input === null || input === '')) {
        // Null and empty string is allowable when the field is not required
        return true;
    }
    // Credit Card numbers are treated as strings
    if (typeof input !== 'string') {
        return false;
    }
    // Allow formatted and unformatted card numbers
    if (input.length !== 16 && input.length !== 19) {
        return false;
    }
    // Regex: 4 digits, optional space, 4 digits, optional space, 4 digits, optional space, 4 digits
    var matches = input.match(/^\d{4,4}\s?\d{4,4}\s?\d{4,4}\s?\d{4,4}$/);
    if (matches !== null) {
        return true;
    }
    return false;
};
/**
 * Validate an email address
 */
exports.isEmailAddress = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && (input === null || input === '')) {
        // Null and empty string is allowable when the field is not required
        return true;
    }
    if (typeof input === 'string' && input.length > 3) {
        // Regex is taking from MDN docs
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email
        // tslint:disable:max-line-length
        var match = input.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);
        // tslint:enable:max-line-length
        if (match !== null) {
            return true;
        }
    }
    return false;
};
/**
 * Validate a date
 *
 * If a string is passed, it will be checked in 'YYYY-MM-DD' and 'DD/MM/YYYY' formats
 * The function will create a date with the string and verify that the enters day, month,
 * year are returned the same to detect issues like "29/02/2019" which would be converted
 * to "01/03/2019" without erroring.
 *
 * @param input
 */
exports.isDate = function (input, required) {
    if (required === void 0) { required = true; }
    if (!required && (input === null || input === '')) {
        // Null and empty string is allowable when the field is not required
        return true;
    }
    if (typeof input === 'object') {
        if (typeof input.getUTCDate === 'function') {
            return true;
        }
        else {
            return false;
        }
    }
    var patternY = '([1-2][0-9]{3,3})';
    var patternM = '([0-1][0-9])';
    var patternD = '([0-3][0-9])';
    var regex;
    var matches;
    var day = 0;
    var month = 0;
    var year = 0;
    // Test for YYYY-MM-DD
    regex = new RegExp("^" + patternY + "-" + patternM + "-" + patternD + "$");
    matches = regex.exec(input);
    if (matches) {
        year = parseInt(matches[1], 10);
        month = parseInt(matches[2], 10);
        day = parseInt(matches[3], 10);
    }
    else {
        // Test for DD/MM/YYYY
        regex = new RegExp("^" + patternD + "/" + patternM + "/" + patternY + "$");
        matches = regex.exec(input);
        if (matches) {
            year = parseInt(matches[3], 10);
            month = parseInt(matches[2], 10);
            day = parseInt(matches[1], 10);
        }
    }
    if (matches === null || year === 0) {
        return false;
    }
    if (month === 0 || month > 12) {
        return false;
    }
    if (day === 0 || day > 31) {
        return false;
    }
    try {
        var dateString = year + "-";
        if (month < 10) {
            dateString += '0';
        }
        dateString += month + "-";
        if (day < 10) {
            dateString += '0';
        }
        dateString += day + "T00:00:00.000Z";
        var date = new Date(dateString);
        if (date.getUTCFullYear() !== year) {
            /* istanbul ignore next */
            return false;
        }
        if (date.getUTCMonth() + 1 !== month) {
            return false;
        }
        if (date.getUTCDate() !== day) {
            /* istanbul ignore next */
            return false;
        }
        // All good!
        return true;
    }
    catch (_a) {
        // Error creating date object with the string
        /* istanbul ignore next */
        return false;
    }
};
